import { render, staticRenderFns } from "./arvioitavan-kokonaisuuden-kategoria-form.vue?vue&type=template&id=6f505def&scoped=true&"
import script from "./arvioitavan-kokonaisuuden-kategoria-form.vue?vue&type=script&lang=ts&"
export * from "./arvioitavan-kokonaisuuden-kategoria-form.vue?vue&type=script&lang=ts&"
import style0 from "./arvioitavan-kokonaisuuden-kategoria-form.vue?vue&type=style&index=0&id=6f505def&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f505def",
  null
  
)

export default component.exports